<div class="search-box">
  <div class="search-row">
    <div class="search-type-wrap">
      <p-select
        [options]="searchTypes"
        [(ngModel)]="searchType"
        optionLabel="label"
        optionValue="value"
        (onChange)="onSearchTypeChange()"
        appendTo="body">
      </p-select>
    </div>

    <div class="search-input-area">
      <ng-container *ngIf="searchType === 'address'">
        <input
          type="text"
          class="search-input"
          placeholder="Vpišite naslov"
          autocomplete="off"
          [(ngModel)]="selectedtext"
          (input)="onAddressSearch()"
          (focus)="onInputFocus()"
          (keyup.enter)="onEnterPressed()"
        />

        <div class="search-dropdown" *ngIf="dropdownOpen && results?.length > 0">
          <div
            class="search-item"
            *ngFor="let result of results"
            (click)="onSelect(result)">
            <div class="search-item-title">{{ result.naslov }}</div>
            <div class="search-item-subtitle">ID: {{ result._na_mid }}</div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="searchType === 'ko_id_st_id'">
        <div class="search-double-input">
          <input
            type="number"
            class="search-input"
            placeholder="Vpišite ko id"
            autocomplete="off"
            [(ngModel)]="ko_id"
            (input)="onKoIdStIdSearch()"
            (focus)="onInputFocus()"
            (keydown)="blockInvalidKeys($event)"
          />

          <input
            type="number"
            class="search-input"
            placeholder="Vpišite št. stavbe"
            autocomplete="off"
            [(ngModel)]="st_id"
            (input)="onKoIdStIdSearch()"
            (keydown)="blockInvalidKeys($event)"
            (focus)="onInputFocus()"
            (keyup.enter)="onEnterPressed()"
          />
        </div>

        <div class="search-dropdown" *ngIf="dropdownOpen && results?.length > 0">
          <div
            class="search-item search-item-detailed"
            *ngFor="let result of results"
            (click)="onSelect(result)">
            <div><strong>Naslov:</strong> {{ result.naslov }}</div>
            <div><strong>Občina:</strong> {{ result.obcina }}</div>
            <div><strong>ID:</strong> {{ result._na_mid }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>